// The platform at the boot of a page (mobile-apps.md §4, R2927): the page
// decides once whether it runs in a store app, and the iOS app shell takes
// the presses on off-origin anchors.

import { installLinkBridge } from './links';
import { storeApp } from './platform';

/** Decides the platform and installs the link bridge. The game page, the
 *  arcade page and the replay page call it before they draw. */
export function bootPlatform(): void {
  if (storeApp() === 'ios') installLinkBridge();
}
